// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__ZC0RM","partnerLogos":"Partners_partnerLogos__1XKZJ","logoWrapper":"Partners_logoWrapper__ZayYM"};